import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppNoInfo } from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import Translator from '../../../../../components/helpers/Translator';
import CustomMessage from './CustomTexts/CustomMessage';
import useIsMounted from '../../../../../components/hooks/useIsMounted';

const CustomTextsTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const customObligationTexts = useSelector(
    (s) => s.currentPage?.customObligationTextsTabs?.[plantObligationID]
  );
  const customObligationTextsPermissions = useSelector(
    (s) =>
      s.module?.[moduleBridgeHex]?.permissions?.gcl?.module?.plant
        ?.customObligationTexts
  );
  const [isLoading, setIsLoading] = useState(false);

  // > LOAD INFORMATION TAB
  useEffect(() => {
    if (!customObligationTexts) {
      setIsLoading(true);
      (async () => {
        try {
          const response = await axios.post(
            axiosPath(
              "api_r_user_module_legalCompliance_customObligationTexts_tab"
            ),
            { moduleBridgeHex, plantHex, plantObligationID }
          );
          if (isMounted.current) {
            dispatch(
              currentPageAction.change('customObligationTextsTabs', {
                [plantObligationID]: response.data,
              })
            );
            setIsLoading(false);
          }
        } catch (err) {}
      })();
    }
  }, []);
  // < LOAD INFORMATION TAB

  if (isLoading) return <AppNoInfo minHeight={300} />;
  return (
    <TabContainer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 mb-3">
            <small className="text-danger">
              *
              <Translator
                file="module-legalCompliance"
                name="custom.text.warning.3"
              />
            </small>
          </div>
        </div>
        <div className="row">
          {customObligationTextsPermissions?.evidence && (
            <div
              className={`col-sm-12 ${
                customObligationTextsPermissions?.nextDate
                  ? 'col-md-6'
                  : 'col-md-12'
              }`}
            >
              <CustomMessage
                plantObligationID={plantObligationID}
                type="evidence"
              />
            </div>
          )}
          {customObligationTextsPermissions?.nextDate && (
            <div
              className={`col-sm-12 ${
                customObligationTextsPermissions?.evidence
                  ? 'col-md-6'
                  : 'col-md-12'
              }`}
            >
              <CustomMessage
                plantObligationID={plantObligationID}
                type="nextDate"
              />
            </div>
          )}
        </div>
      </div>
    </TabContainer>
  );
};
export default CustomTextsTab;

const TabContainer = styled.div`
  height: 367px;
  overflow-y: auto;
`;
